import { PaperWallet } from '@thirdweb-dev/wallets';
import { useConnect } from '@thirdweb-dev/react-core';
import { useRef, useEffect } from 'react';
import { a as Flex, b as Spinner } from './basic-72632cb3.browser.esm.js';
import { I as InputSelectionUI } from './InputSelectionUI-df66b9d3.browser.esm.js';
import { jsx } from 'react/jsx-runtime';
import '@emotion/react';
import '@emotion/styled';
import '@radix-ui/colors';
import '@radix-ui/react-icons';

const paperWallet = config => {
  return {
    id: PaperWallet.id,
    meta: PaperWallet.meta,
    create(options) {
      return new PaperWallet({
        ...options,
        ...config
      });
    },
    config,
    selectUI: PaperSelectionUI,
    connectUI: PaperConnectionUI
  };
};
const PaperSelectionUI = props => {
  return /*#__PURE__*/jsx(InputSelectionUI, {
    onSelect: props.onSelect,
    placeholder: "Enter your email address",
    name: "email",
    type: "email",
    errorMessage: input => {
      const emailRegex = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,})$/g;
      const isValidEmail = emailRegex.test(input);
      if (!isValidEmail) {
        return "Invalid email address";
      }
    },
    emptyErrorMessage: "email address is required",
    supportedWallets: props.supportedWallets
  });
};
const PaperConnectionUI = _ref => {
  let {
    close,
    walletConfig,
    open,
    selectionData,
    supportedWallets
  } = _ref;
  const connectPrompted = useRef(false);
  const connect = useConnect();
  const singleWallet = supportedWallets.length === 1;
  useEffect(() => {
    if (connectPrompted.current) {
      return;
    }
    connectPrompted.current = true;
    (async () => {
      close();
      try {
        await connect(walletConfig, {
          email: selectionData
        });
      } catch (e) {
        if (!singleWallet) {
          open();
        }
        console.error(e);
      }
    })();
  }, [connect, walletConfig, close, open, singleWallet, selectionData]);
  return /*#__PURE__*/jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    style: {
      minHeight: "250px"
    },
    children: /*#__PURE__*/jsx(Spinner, {
      size: "md",
      color: "primary"
    })
  });
};

export { paperWallet };
